import React from "react";

const MdsSection = ({ children, className = "", hasMaxWidth = true }) => {
  return (
    <section
      data-component="section"
      className={`${
        hasMaxWidth ? "max-w-screen-xxl" : ""
      } w-full mx-auto px-x ${className}`}
    >
      {children}
    </section>
  );
};

export default MdsSection;
